import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import './AdminMenu.scss';
// import msgs from '../../config/messages';
// import NFButton from '../primitives/NFButton';
import AdminCaps from '../../config/searchFilters/AdminFilters';

// Components
import FilterGroup from '../FilterGroup';

export default class AdminMenu extends React.PureComponent {
  static propTypes = {
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func,
    // onToolFilter: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedMenu: { value: 'viewUsers' },
    onMenuClick: () => { },
  };

  // _clearPartNumDes = () => {
  //   document.getElementById('partNum').value = '';
  //   document.getElementById('description').value = '';
  // };
  // _clearNiinDesc = () => {
  //   document.getElementById('niin').value = '';
  //   document.getElementById('description').value = '';
  // };
  // _clearNiinPartNum = () => {
  //   document.getElementById('niin').value = '';
  //   document.getElementById('partNum').value = '';
  // };

  // _clearFilters = () => {
  //   window.location.reload();
  // };

  render() {
    const { selectedMenu, onMenuClick } = this.props;
    return (
      <div className="nf-solicitations-menu">
        <FilterGroup
          {...AdminCaps}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminMenu/AdminMenu.jsx